import { API } from '../Api';
import { AlertTier } from '../../utils/donate-alert';

// Hiệu ứng donate theo mốc tiền (payment-service).

export interface MyAlertTiers {
  isPremium: boolean;
  maxTiers: number;
  /** Hệ thống đang để kiểu Nổi bật/Đặc biệt cho CAB+ và creator chưa có CAB+. */
  kindsLocked?: boolean;
  tiers: AlertTier[];
}

export const getMyAlertTiers = () =>
  API.get<MyAlertTiers>('/v1/payment-service/donate-alert-tiers/me').then((r) => r.data);

export const saveAlertTiers = (tiers: AlertTier[]) =>
  API.put<MyAlertTiers>('/v1/payment-service/donate-alert-tiers', {
    tiers: tiers.map(
      ({
        minAmount,
        sound,
        image,
        durationSec,
        textColor,
        readAloud,
        template,
        kind,
        introEnabled,
        medalEnabled,
        effectEnabled,
        voice,
      }) => ({
        minAmount,
        sound,
        image,
        durationSec,
        textColor,
        readAloud,
        template,
        kind: kind || 'normal',
        introEnabled: introEnabled ?? null,
        medalEnabled: medalEnabled ?? null,
        effectEnabled: effectEnabled ?? null,
        voice: voice || null,
      })
    ),
  }).then((r) => r.data);

// Công khai — overlay OBS đọc được không cần đăng nhập.
export const getPublicAlertTiers = (userId: string) =>
  API.get<AlertTier[]>('/v1/payment-service/public/creator-alert-tiers', {
    params: { userId },
  }).then((r) => r.data);

export const sendTestAlert = (minAmount?: number) =>
  API.post<{ sent: boolean }>('/v1/payment-service/donate-alert-tiers/test-alert', { minAmount }).then(
    (r) => r.data
  );
